/* src/modules/students/reducers.js */

import { combineReducers } from 'redux';
import { keyBy } from 'lodash';

import {
  fetchStudentsTypes,
  fetchStudentTypes,
  addCreditsTypes,
  CLEAR_SELECTED_STUDENT,
} from './action_types';

import { ON_ERROR } from '../app_state/action_types';

import { makeRequestReducer } from '../../config/client';

const main = makeRequestReducer({
  types: fetchStudentsTypes,
  name: 'students',
  mutate: (state, res) => keyBy(res, '_id'),
  append: [(state, action) => {
    switch (action.type) {
      case ON_ERROR:
        return { ...state, data: {} };
      default:
        return state;
    }
  }],
});

const single = makeRequestReducer({
  types: fetchStudentTypes,
  name: 'studentByID',
  append: [
    (state, action) => {
      switch (action.type) {
        case CLEAR_SELECTED_STUDENT:
        case ON_ERROR:
          return { ...state, data: {} };
        default:
          return state;
      }
    },
    makeRequestReducer({
      types: addCreditsTypes,
      name: 'addCredits',
    }),
  ],
});

export default combineReducers({
  main,
  single,
});



// WEBPACK FOOTER //
// ./src/modules/students/reducers.js